import MyModal from '../../../components/Modal';
import { Dispatch, SetStateAction } from 'react';
import { ClientUserBeingRemovedType } from '../types';

interface IDeleteClientUser { clientUserCode: number }

interface DeleteModalInterface {
  clientUserBeingRemoved: ClientUserBeingRemovedType;
  setDeleteModalShow: Dispatch<SetStateAction<boolean>>;
  deleteClientUser: ({ clientUserCode }: IDeleteClientUser) => void;
  deleteModalShow: boolean;
}

export default function DeleteModal({
  clientUserBeingRemoved,
  setDeleteModalShow,
  deleteClientUser,
  deleteModalShow,
}: DeleteModalInterface) {
  return (
    <MyModal
      title={`Deletar usuário ${clientUserBeingRemoved.name}`}
      closeButtonLabel="Cancelar"
      actionButtonLabel={'Deletar'}
      modalBody={(
        <div>
          {'Tem certeza que deseja deletar o usuário'}
          {' '}
          <strong>{clientUserBeingRemoved.name}</strong>
          {' '}
          ?
        </div>
      )}
      onClose={() => setDeleteModalShow(false)}
      onAction={() => deleteClientUser({
        clientUserCode: clientUserBeingRemoved.clientUserCode,
      })}
      show={deleteModalShow}
      type={'deleteAction'}
    />
  );
}
